import { createSlice } from "@reduxjs/toolkit"

const initialState = {
  listDepartment: [],
  listProvince: [],
  listPersonnel: [],
  listPersonnelAssigner: [],
  departmentId: null,
}

export const hrSlice = createSlice({
  name: "hr",
  initialState,
  reducers: {
    sliceDepartments: (state, action) => {
      state.listDepartment = action.payload
    },
    setListProvince: (state, action) => {
      state.listProvince = action.payload
    },
    setListPersonnel: (state, action) => {
      state.listPersonnel = action.payload
    },
    setListPersonnelAssigner: (state, action) => {
      state.listPersonnelAssigner = action.payload
    },
    setDepartmentId: (state, action) => {
      state.departmentId = action.payload // ✅ set phòng ban
    },
  },
})

export const {
  sliceDepartments,
  setListProvince,
  setListPersonnel,
  setListPersonnelAssigner,
  setDepartmentId,
} = hrSlice.actions

export default hrSlice.reducer
